export const PLAN_CATALOG = {
  solo: {
    code: "solo",
    name: "Solo",
    seatLimit: 1,
    seatLabel: "1 user",
    description: "A focused workspace for an independent relationship owner.",
  },
  team: {
    code: "team",
    name: "Team",
    seatLimit: 5,
    seatLabel: "Up to 5 users",
    description: "Shared follow-up, tasks, events, and reporting for a small team.",
  },
  growth: {
    code: "growth",
    name: "Growth",
    seatLimit: 10,
    seatLabel: "6–10 users",
    description: "More capacity for a growing referral and business-development team.",
  },
  scale: {
    code: "scale",
    name: "Scale",
    seatLimit: 100,
    seatLabel: "20–100 users",
    description: "Organization-wide access, controls, and performance visibility.",
  },
} as const;

export type PlanCode = keyof typeof PLAN_CATALOG;

export function isPlanCode(value: string): value is PlanCode {
  return Object.hasOwn(PLAN_CATALOG, value);
}

export function planForCode(code: string) {
  return isPlanCode(code) ? PLAN_CATALOG[code] : PLAN_CATALOG.team;
}
